import { put } from 'redux-saga/effects';
import * as myItemsActions from 'store/myItems/store/actions';

function* changeFilters() {
  yield put(myItemsActions.resetMyItems());
  yield put(myItemsActions.fetchMyItems({ isFetching: true }));
}

export default changeFilters;
